import { render, staticRenderFns } from "./products-business.demo.vue?vue&type=template&id=280956b3&"
import script from "./products-business.demo.vue?vue&type=script&lang=js&"
export * from "./products-business.demo.vue?vue&type=script&lang=js&"
import style0 from "./products-business.demo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "products-business.demo.vue"
export default component.exports